import { Bell, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import UserAvatar from '@/components/UserAvatar';
import { useSession } from '@/store/session';
import { useAppStoreOptional } from '@/store/AppStoreProvider';
import { usePreferences } from '@/store/preferences';
import nextchampLogo from '@/assets/nextchamp-logo-transparent.png';

const Header = () => {
  const navigate = useNavigate();
  const { currentUser, currentUserId } = useSession();
  const { t } = usePreferences();

  // Optional: the header can render outside the app store (onboarding chrome).
  const store = useAppStoreOptional();
  const unreadCount =
    store && currentUserId ? store.notification.getUnreadCount(currentUserId) : 0;

  return (
    <header className="sticky top-0 z-50 flex items-center justify-between border-b border-border bg-background/95 px-4 py-3 backdrop-blur-sm">
      <div className="flex flex-1 items-center">
        <img src={nextchampLogo} alt="Nextchamp logo" className="h-7 w-7 object-contain" />
      </div>
      <h1 className="text-lg font-extrabold uppercase tracking-widest text-foreground">
        Nextchamp
      </h1>
      <div className="flex flex-1 items-center justify-end gap-0.5">
        <button
          onClick={() => navigate('/notifications')}
          className="relative rounded-full p-2 text-muted-foreground transition-colors press-scale hover:text-foreground"
          aria-label={t.notifications}
        >
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-primary-foreground">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>
        <button
          onClick={() => navigate('/settings')}
          className="rounded-full p-2 text-muted-foreground transition-colors press-scale hover:text-foreground"
          aria-label={t.settings}
        >
          <Settings className="h-5 w-5" />
        </button>
        {currentUser && (
          <button
            onClick={() => navigate(`/profile/${currentUser.id}`)}
            className="ml-1 press-scale"
            aria-label={t.profile}
          >
            <UserAvatar avatarUrl={currentUser.avatarUrl} initials={currentUser.initials} className="h-7 w-7" fallbackClassName="text-[10px]" />
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
